import { defineStore } from 'pinia';
import { EntityItemList } from '@/entities/entityItem';
import { EntityItemQuery } from '@/services/api/resources/entityItem/query';
import isEqual from 'lodash/isEqual';

type NullableEntityItemList = EntityItemList | null;

interface State {
  items: Array<{query: EntityItemQuery; entityItems: NullableEntityItemList}>;
}

export const useEntityItemsStore = defineStore('entityItems', {
  state: (): State => ({ items: [] }),
  actions: {
    setEntityItems(query: EntityItemQuery, entityItems: EntityItemList) {
      this.items.push({ query, entityItems });
    },
    getByQuery(query: EntityItemQuery) {
      return this.items.find(item => isEqual(item.query, query));
    },
    isCached(query: EntityItemQuery) {
      return this.items.some(item => isEqual(item.query, query));
    },
  },
});
